var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"w-notification",class:_vm.value.classes,on:{"click":function($event){$event.preventDefault();return _vm.dismiss()}}},[_c('div',[(_vm.value.icon)?_c('w-fa',{attrs:{"icon":_vm.value.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.value.text)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }